import { QRWhatsapp } from "./qr-whatsapp";

export { QRWhatsapp };
